import { render, staticRenderFns } from "./CategoryFilterOption.vue?vue&type=template&id=341fb8d0&"
import script from "./CategoryFilterOption.vue?vue&type=script&lang=js&"
export * from "./CategoryFilterOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports